import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { IconX } from "@tabler/icons-react";
import {
    getEvents,
    getAthletesByEvent,
    linkAthleteToEvent,
    updateShooting,
} from "../../../db";

const Events = ({ onClose, shooting }) => {
    const { t } = useTranslation();
    const [events, setEvents] = useState([]);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const allEvents = await getEvents();
                const sorted = allEvents.sort((a, b) => b.date - a.date);
                setEvents(sorted);
            } catch (error) {
                console.error("Failed to load events:", error);
            }
        };
        fetchEvents();
    }, []);

    const handleSelectEvent = async (eventId) => {
        if (shooting.athlete && eventId) {
            const athletes = await getAthletesByEvent(eventId);
            const isAvailable = athletes.some(a => a.id === shooting.athlete);

            if (!isAvailable) {
                const confirmAdd = window.confirm(t("shooting.addAthleteToEventConfirmation"));
                if (confirmAdd) {
                    await linkAthleteToEvent(shooting.athlete, eventId);
                } else {
                    await updateShooting(shooting.id, {event: eventId, athlete: null});
                    onClose();
                    return;
                }
            }
        }

        await updateShooting(shooting.id, { event: eventId });
        onClose();
    };

    return (
        <div className="fixed inset-0 z-30 flex items-center justify-center">
            <div className="bg-black opacity-60 absolute inset-0" onClick={onClose}></div>
            <div className="bg-white p-10 relative w-[90rem] max-w-[90svw] max-h-[90svh] overflow-y-auto">
                <button onClick={onClose} className="absolute right-0 top-0 p-2 bg-[var(--light-color)] text-[var(--dark-color)]">
                    <IconX className="w-6 h-auto" />
                </button>
                <div className="grid gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 text-xs px-2">
                    {events.map(event => (
                        <button
                            key={event.id}
                            className={`${(shooting.event === event.id) ? 'button-primary' : 'button-secondary'} flex-col !items-start justify-between`}
                            onClick={() => handleSelectEvent(event.id)}
                        >
                            <strong>{event.title || t("shooting.event.untitled")}</strong>
                            <div className="text-gray-500 text-xs">
                                {new Intl.DateTimeFormat("cs-CZ", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric"
                                }).format(new Date(event.date * 1000))}
                            </div>
                        </button>
                    ))}
                </div>
                <div className="mt-6 px-2 text-xs">
                    <button
                        className={`${!shooting.event ? 'button-primary !bg-[var(--dark-color)] !text-[var(--light-color)]' : 'button-secondary'} !border-[var(--dark-color)] flex-col !items-start justify-between`}
                        onClick={() => handleSelectEvent(false)}
                    >
                        {t("shooting.noEvent")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Events;